/** Planet base RGB for avatar glow - matches navagraha nature tints in Jyotisha intro. */

/** @type {Record<string, string>} */
export const AVATAR_PLANET_RGB = {
  mars: '248, 113, 113',
  sun: '251, 191, 36',
  moon: '186, 230, 253',
  mercury: '45, 212, 191',
  jupiter: '202, 138, 4',
  venus: '244, 114, 182',
  saturn: '100, 116, 139',
  rahu: '139, 92, 246',
  ketu: '161, 98, 7',
  zodiac: '129, 140, 248',
  navagraha: '251, 191, 36',
};

/** Chaldean numerology digit → navagraha glow key */
const NUMERO_PLANET_BY_DIGIT = {
  1: 'sun',
  2: 'moon',
  3: 'jupiter',
  4: 'rahu',
  5: 'mercury',
  6: 'venus',
  7: 'ketu',
  8: 'saturn',
  9: 'mars',
};

const PLANET_PREFIXES = [
  'navagraha',
  'zodiac-constellation',
  'moon',
  'mercury',
  'jupiter',
  'venus',
  'saturn',
  'mars',
  'sun',
  'rahu',
  'ketu',
];

/** @param {string | null | undefined} avatarId */
export function getAvatarPlanetKey(avatarId) {
  if (!avatarId) return 'sun';
  const id = avatarId.toLowerCase();
  if (id.startsWith('numero-')) {
    const digit = Number.parseInt(id.split('-')[1], 10);
    return NUMERO_PLANET_BY_DIGIT[digit] ?? 'sun';
  }
  for (const prefix of PLANET_PREFIXES) {
    if (id.startsWith(prefix)) {
      if (prefix === 'zodiac-constellation') return 'zodiac';
      if (prefix === 'navagraha') return 'navagraha';
      return prefix;
    }
  }
  return 'sun';
}

/** @param {string | null | undefined} avatarId */
export function getAvatarPlanetRgb(avatarId) {
  const key = getAvatarPlanetKey(avatarId);
  return AVATAR_PLANET_RGB[key] ?? AVATAR_PLANET_RGB.sun;
}
